<div>
    <div>
        <div class="mb-2 d-flex justify-content-between align-items-start" *ngIf="cvDetails?.length > 0">
            <div class="d-flex align-items-center" style="width: 75%;">
                <span class="f-14 font-weight-600">Add New File</span>
            </div>
            <div class="text-right">
                <input data-testid="auto-app-document-tab-input-1" class="d-none" type="file" accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html" (change)="uploadFile($event)" #csvinput />
                <button data-testid="auto-app-document-tab-button-1" class="btn-trms-light pointer" (click)="csvinput.click()"><i class="fa-regular fa-plus"></i> Add File </button>
            </div>
            <p *ngIf="incorrectFileFormat" class="text-danger f-12 pt-1">
                Invalid File Extension
            </p>
        </div>
    </div>
    <div class="mb-2 d-flex justify-content-between align-items-center onHover" *ngFor="let file of cvDetails">
        <div class="d-flex align-items-center" style="width: 65%;">
            <span class="mr-2">
                <span class="note-icon"><i class="fa-light fa-file"></i></span>
            </span>
            <span> {{file?.filename}}</span>
        </div>
        <div class="f-12 text-9696 onhoverdisplay">{{file?.firstname}} {{file?.lastname}} <i class="fas fa-circle f-10 mx-3" style="font-size: 5px;"></i>{{file?.createdon | date: 'dd MMM yyyy'}}</div>
        <span class="text-right onhverEdit">
            <span class="mr-2 ats-cta-btn" title="Preview File" (click)="previewFile(file)"> <i class="fas fa-eye f-12"></i> </span>
            <span class="mr-2 ats-cta-btn" title="Download file" (click)="downloadCV()"> <i class="fas fa-download f-12"></i> </span>
            <span class="mr-2 ats-cta-btn" title="Archive file" (click)="opendeleteCVModal()"> <i class="fas fa-trash f-12"></i> </span>
        </span>
    </div>

    <hr class="my-3" />
</div>


<div *ngIf="iscvDetailsLoader && cvDetails.length == 0" class="w-100 d-flex justify-content-center">
    <img src="../../assets/rolling-loader.gif" style="width: 50px;" alt="" />
</div>

<div *ngIf="cvDetails.length == 0 && !iscvDetailsLoader">
    <div class="col wccard text-center pt-6">
        <div class="col-md-10 py-6 m-auto">
            <img src="../../../assets/images/search-engine-1.png" class="img-fluid" alt="" srcset="" />
        </div>
        <div class="">
            <p class="font-weight-500 gray-text">Nothing to see here</p>
        </div>
        <div class="d-flex justify-content-center">
            <input data-testid="auto-app-document-tab-input-2" class="d-none" type="file" accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html" (change)="uploadFile($event)" #csvinput />
            <button data-testid="auto-app-document-tab-button-2" class="btn-trms-medium"  type="submit" data-dismiss="modal" [disabled]="fileUploadSpinner" (click)="csvinput.click()" style="width: 160px;">
                <span [ngClass]="{ 'spinner-border spinner-size': fileUploadSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': fileUploadSpinner }">
                  {{fileUploadSpinner ? '' : 'Browse files'}}
                </span>
            </button>
        </div>
        <p *ngIf="incorrectFileFormat" class="text-danger f-12 pt-1">
            Invalid File Extension
        </p>
    </div>
</div>

<ng-template #deletecv>
    <div class="modal-header b pb-0">
        <h5 class="modal-title" id="experience"></h5>
        <button data-testid="auto-app-document-tab-button-3" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="modalService.dismissAll()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body pb-6">
        <div class="row mb-6">
            <div class="col text-center">
                <p>Are you sure you want to delete this document?</p>
                <p></p>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-10 mx-auto d-flex">
                <button data-testid="auto-app-document-tab-button-4" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
                <button data-testid="auto-app-document-tab-button-5" class="btn-trms-small" (click)="deleteCV()">YES</button>
            </div>
        </div>
    </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>